module.exports = __webpack_public_path__ + "static/img/glsmall02.4a0ee86b.jpg";